import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import EditorPicks from "./components/EditorPicks";
import DailyPicks from "./components/DailyPicks";
import HiddenGems from "./components/HiddenGems";
import MonthlyHot from "./components/MonthlyHot";
import PrivateCollection from "./components/PrivateCollection";
import About from "./components/About";
import FAQ from "./components/FAQ";
import Newsletter from "./components/Newsletter";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "小秘漫画网的推荐是怎么选出来的？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "每一部作品都由编辑部成员完整阅读后，从故事立意、画风表现、节奏把控与情绪共鸣四个维度打分，再结合书友反馈综合筛选，确保推荐有据可依。",
      },
    },
    {
      "@type": "Question",
      name: "推荐的漫画在哪里可以阅读？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "我们只负责帮你挑出值得一读的作品，并在每部作品的推荐卡片中标注题材与特点。具体阅读渠道请以官方正版平台为准，我们始终倡导支持正版。",
      },
    },
    {
      "@type": "Question",
      name: "为什么有些「冷门佳作」我搜不到热度？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "这正是「秘书严选」栏目的意义所在——它们往往被流量淹没，却拥有极高的完成度。我们会用详细的推荐语说明它值得读在哪里，避免你踩坑浪费时间。",
      },
    },
    {
      "@type": "Question",
      name: "网站上的评分靠谱吗？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "评分综合了编辑部精读体验与书友打分，相对稳定但并非绝对权威。不同题材的口味差异很大，建议把评分当作参考，结合推荐语判断是否合你胃口。",
      },
    },
    {
      "@type": "Question",
      name: "每日精选一般几点更新？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "每日精选通常在早上 9 点前更新，周末与节假日也照常更新。你随时回来都能看到当天的选题与搭配，也可以按题材分类快速浏览全部精选。",
      },
    },
    {
      "@type": "Question",
      name: "我可以投稿推荐自己喜欢的漫画吗？",
      acceptedAnswer: {
        "@type": "Answer",
        text: "当然可以。欢迎通过页面底部的联系方式把你的心头好发给我们，编辑部会认真阅读并评估，优质推荐有机会进入正式的推荐栏目。",
      },
    },
  ],
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "小秘漫画网",
  url: "https://toonseek.github.io/",
  description:
    "小秘漫画网提供编辑推荐书单、每日精选好漫、秘书严选冷门佳作、本月热荐与编辑私藏，帮你轻松找到值得一读的漫画。",
  potentialAction: {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: "https://toonseek.github.io/?s={search_term_string}",
    },
    "query-input": "required name=search_term_string",
  },
};

const orgSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "小秘漫画网",
  url: "https://toonseek.github.io/",
  logo: "https://toonseek.github.io/logo.png",
  email: "hello@xiaomi-comic.cn",
  description:
    "专注漫画编辑推荐与策展的内容网站，提供编辑推荐、每日精选、秘书严选、本月热荐与编辑私藏等栏目。",
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <Navbar />
      <main>
        <Hero />
        <EditorPicks />
        <DailyPicks />
        <HiddenGems />
        <MonthlyHot />
        <PrivateCollection />
        <About />
        <FAQ />
        <Newsletter />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}